"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var errors_1 = require("@ledgerhq/errors");
var deviceAccess_1 = require("../../hw/deviceAccess");
var operation_1 = require("../../operation");
var js_buildTransaction_1 = require("./js-buildTransaction");
var ledgerjs_hw_app_cardano_1 = __importStar(require("@cardano-foundation/ledgerjs-hw-app-cardano"));
var logic_1 = require("./logic");
var ShelleyTypeAddress_1 = __importDefault(require("@stricahq/typhonjs/dist/address/ShelleyTypeAddress"));
var networks_1 = require("./networks");
var constants_1 = require("./constants");
var buildOptimisticOperation = function (account, transaction, t) {
    var _a;
    var cardanoResources = account.cardanoResources;
    var accountCreds = new Set(__spreadArray(__spreadArray([], __read(cardanoResources.externalCredentials), false), __read(cardanoResources.internalCredentials), false).map(function (cred) { return cred.key; }));
    var accountInput = transaction
        .getInputs()
        .reduce(function (total, i) {
        return accountCreds.has(i.address.paymentCredential.hash)
            ? total.plus(i.amount)
            : total.plus(0);
    }, new bignumber_js_1.BigNumber(0));
    var accountOutput = transaction
        .getOutputs()
        .reduce(function (total, o) {
        return o.address instanceof ShelleyTypeAddress_1["default"] &&
            accountCreds.has(o.address.paymentCredential.hash)
            ? total.plus(o.amount)
            : total.plus(0);
    }, new bignumber_js_1.BigNumber(0));
    var accountChange = accountOutput.minus(accountInput);
    var opType = (0, logic_1.getOperationType)({
        valueChange: accountChange,
        fees: transaction.getFee()
    });
    var transactionHash = transaction.getTransactionHash().toString("hex");
    var auxiliaryData = transaction.getAuxiliaryData();
    var memo;
    if (auxiliaryData) {
        var memoMetadata = auxiliaryData.metadata.find(function (m) { return m.label === constants_1.MEMO_LABEL; });
        if (memoMetadata && memoMetadata.data instanceof Map) {
            var msg = memoMetadata.data.get("msg");
            if (Array.isArray(msg) && msg.length) {
                memo = msg.join(", ");
            }
        }
    }
    var extra = {};
    if (memo) {
        extra["memo"] = memo;
    }
    var op = {
        id: (0, operation_1.encodeOperationId)(account.id, transactionHash, opType),
        hash: transactionHash,
        type: opType,
        value: accountChange.absoluteValue(),
        fee: transaction.getFee(),
        blockHash: undefined,
        blockHeight: null,
        senders: transaction.getInputs().map(function (i) { return i.address.getBech32(); }),
        recipients: transaction.getOutputs().map(function (o) { return o.address.getBech32(); }),
        accountId: account.id,
        date: new Date(),
        extra: extra
    };
    var tokenAccount = t.subAccountId
        ? (_a = account.subAccounts) === null || _a === void 0 ? void 0 : _a.find(function (ta) { return ta.id === t.subAccountId; })
        : null;
    if (tokenAccount && opType === "OUT") {
        op.subOperations = [
            {
                id: (0, operation_1.encodeOperationId)(tokenAccount.id, transactionHash, opType),
                hash: transactionHash,
                type: opType,
                value: t.useAllAmount ? tokenAccount.balance : t.amount,
                fee: t.fees,
                blockHash: undefined,
                blockHeight: null,
                senders: transaction.getInputs().map(function (i) { return i.address.getBech32(); }),
                recipients: transaction.getOutputs().map(function (o) { return o.address.getBech32(); }),
                accountId: tokenAccount.id,
                date: new Date(),
                extra: {}
            },
        ];
    }
    return op;
};
/**
 * Adds signatures to unsigned transaction
 */
var signTx = function (unsignedTransaction, accountKey, witnesses) {
    witnesses.forEach(function (witness) {
        var _a = __read(witness.path, 5), chainType = _a[3], index = _a[4];
        var publicKey = accountKey
            .derive(chainType)
            .derive(index)
            .toPublicKey()
            .toBytes();
        var vKeyWitness = {
            signature: Buffer.from(witness.witnessSignatureHex, "hex"),
            publicKey: Buffer.from(publicKey)
        };
        unsignedTransaction.addWitness(vKeyWitness);
    });
    return unsignedTransaction.buildTransaction();
};
/**
 * Sign Transaction with Ledger hardware
 */
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return new rxjs_1.Observable(function (o) {
            function main() {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var unsignedTransaction, accountPubKey, rawInputs, ledgerAppInputs, rawOutptus, ledgerAppOutputs, auxiliaryDataHashHex, networkParams, network, trxOptions, appAda, r, signed, operation;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                o.next({ type: "device-signature-requested" });
                                if (!transaction.fees) {
                                    throw new errors_1.FeeNotLoaded();
                                }
                                return [4 /*yield*/, (0, js_buildTransaction_1.buildTransaction)(account, transaction)];
                            case 1:
                                unsignedTransaction = _b.sent();
                                accountPubKey = (0, logic_1.getExtendedPublicKeyFromHex)(account.xpub);
                                rawInputs = unsignedTransaction.getInputs();
                                ledgerAppInputs = rawInputs.map(function (i) {
                                    return (0, logic_1.prepareLedgerInput)(i, account.index);
                                });
                                rawOutptus = unsignedTransaction.getOutputs();
                                ledgerAppOutputs = rawOutptus.map(function (o) {
                                    return (0, logic_1.prepareLedgerOutput)(o, account.index);
                                });
                                auxiliaryDataHashHex = unsignedTransaction.getAuxiliaryDataHashHex();
                                networkParams = (0, networks_1.getNetworkParameters)(account.currency.id);
                                network = networkParams.networkId === ledgerjs_hw_app_cardano_1.Networks.Mainnet.networkId
                                    ? ledgerjs_hw_app_cardano_1.Networks.Mainnet
                                    : ledgerjs_hw_app_cardano_1.Networks.Testnet;
                                trxOptions = {
                                    signingMode: ledgerjs_hw_app_cardano_1.TransactionSigningMode.ORDINARY_TRANSACTION,
                                    tx: {
                                        network: network,
                                        inputs: ledgerAppInputs,
                                        outputs: ledgerAppOutputs,
                                        certificates: [],
                                        withdrawals: [],
                                        fee: unsignedTransaction.getFee().toString(),
                                        ttl: (_a = unsignedTransaction.getTTL()) === null || _a === void 0 ? void 0 : _a.toString(),
                                        validityIntervalStart: null,
                                        auxiliaryData: auxiliaryDataHashHex
                                            ? {
                                                type: ledgerjs_hw_app_cardano_1.TxAuxiliaryDataType.ARBITRARY_HASH,
                                                params: {
                                                    hashHex: auxiliaryDataHashHex
                                                }
                                            }
                                            : null
                                    },
                                    additionalWitnessPaths: []
                                };
                                appAda = new ledgerjs_hw_app_cardano_1["default"](transport);
                                return [4 /*yield*/, appAda.signTransaction(trxOptions)];
                            case 2:
                                r = _b.sent();
                                signed = signTx(unsignedTransaction, accountPubKey, r.witnesses);
                                o.next({ type: "device-signature-granted" });
                                operation = buildOptimisticOperation(account, unsignedTransaction, transaction);
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: signed.payload,
                                        expirationDate: null
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
        });
    });
};
exports["default"] = signOperation;
//# sourceMappingURL=js-signOperation.js.map